import React, { useEffect } from 'react';
import { Col, Row, Card, Button } from 'react-bootstrap';
import ProgramList from './ProgramList';
import IconButton from 'components/common/IconButton';
import Form from 'react-bootstrap/Form';
import ProgramForm from './ProgramForm';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import ImportFromPDF from './ImportFromPDF';
import { useNavigate } from 'react-router-dom';
import ImportFromHyroxPDF from './ImportFromHyroxPDF';
import Avatar from 'components/common/Avatar';
const ProgramLandingPage = () => {
  const navigate = useNavigate();
  const [showMayhemImportModal, setShowMayhemImportModal] = React.useState(false);
  const [showHyroxImportModal, setShowHyroxImportModal] = React.useState(false);
  const description = 'Create and manage your workout programs. You can create a program from scratch or import it from a PDF file.';
  const buttons = [];
  const headerGenerated = useHeaderGenerator('Programs', description, buttons);
    const programs = [
      {name: 'Rebirth Cross-Training', key: 'rebirth-ct', image: '/static/media/rebirth-logo-wod.a60d9bfe6643ba94c2fd.png', buttonLabel: 'Use this program'},
      {name: 'Mayhem Affiliate', key: 'mayhem', image: 'https://www.mayhemathletes.com/wp-content/webpc-passthru.php?src=https://www.mayhemathletes.com/wp-content/uploads/2024/08/Affiliate-1024x924.png&nocache=1', buttonLabel: 'Import Mayhem PDF'},
      {name: 'HYROX', key: 'hyrox', image: 'https://prodapilymberfitness.mindbodyonline.com/courses/6453952/original_42_xlarge.jpg?1775826988', buttonLabel: 'Import Hyrox PDF'},
      {name: 'Custom', key: 'custom', image: 'https://www.auraleisure.ie/wp-content/uploads/2021/08/6.png', buttonLabel: 'Add a new program'},
      {name: 'Rebirth Hybrid', key: 'hyrox', image: '/static/media/rebirth-logo-wod.a60d9bfe6643ba94c2fd.png', buttonLabel: 'Use this program'},
      {name: 'AI Generated', key: 'ai-generated', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFd6Lk-d7tNL0E31O3tRHlbiCv__68oNQnyzrMc39odQ&s=10', buttonLabel: 'Generate it with AI'},
    ];
  const handleProgramSelected = (programKey) => {
    switch (programKey) {
      case 'mayhem':
        setShowMayhemImportModal(true);
        setShowHyroxImportModal(false);
        break;
      case 'hyrox':
        setShowMayhemImportModal(false);
        setShowHyroxImportModal(true);
        break;
      case 'custom':
        setShowMayhemImportModal(false);
        setShowHyroxImportModal(false);
        navigate('/app/wod/programs/create-form');
        break;
      case 'ai-generated':
        setShowMayhemImportModal(false);
        setShowHyroxImportModal(false);
        navigate('/app/wod/programs/create-ai-form');
        break;
      default:
        console.error('Unknown program key:', programKey);
    }
  };  
  return (
    <>
      {headerGenerated}

        {programs && (
          <Row className="g-3 mb-3">
          {programs.map((program) => (
            <Col xxl={4} lg={6} key={program.key}>
              <div className="p-3 border bg-light" align="center">
                <h5 className="mb-3">{program.name}</h5>
                <Avatar src={program.image} alt={program.name} size="4xl"/>
                <br/>
                <Button variant="success" className="btn btn-sm m-3" onClick={() => handleProgramSelected(program.key)}>
                  {program.buttonLabel || 'View Program'}
                </Button>
              </div>
            </Col>
          ))}
        </Row>)}
      {showMayhemImportModal && (<Row>
        <Col><ImportFromPDF /></Col>
      </Row>)}
      {showHyroxImportModal && (<Row>
        <Col><ImportFromHyroxPDF /></Col>
      </Row>)}
      <Row className="g-3">
        <Col xxl={12}>
          <ProgramList />
        </Col>
      </Row>
    </>
  );
};

export default ProgramLandingPage;
